import React, { useState, useEffect } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 100;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    setIsMenuOpen(false);
    const target = document.querySelector(targetId);
    if (target) {
      const offsetTop = target.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav className="navbar" style={{
      boxShadow: scrolled 
        ? '0 4px 20px rgba(0, 0, 0, 0.5), 0 0 1px rgba(0, 217, 255, 0.3)'
        : '0 4px 20px rgba(0, 0, 0, 0.5), 0 0 1px rgba(0, 217, 255, 0.3)',
      borderBottomColor: scrolled ? 'rgba(0, 217, 255, 0.4)' : 'rgba(0, 217, 255, 0.3)'
    }}>
      <div className="container">
        <div className="nav-brand">
          <a href="#home" onClick={(e) => handleNavClick(e, '#home')}>Portfolio</a>
        </div>
        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <li><a href="#home" className="nav-link" onClick={(e) => handleNavClick(e, '#home')}>Home</a></li>
          <li><a href="#about" className="nav-link" onClick={(e) => handleNavClick(e, '#about')}>About</a></li>
          <li><a href="#experience" className="nav-link" onClick={(e) => handleNavClick(e, '#experience')}>Experience</a></li>
          <li><a href="#projects" className="nav-link" onClick={(e) => handleNavClick(e, '#projects')}>Projects</a></li>
          <li><a href="#skills" className="nav-link" onClick={(e) => handleNavClick(e, '#skills')}>Skills</a></li>
          <li><a href="#education" className="nav-link" onClick={(e) => handleNavClick(e, '#education')}>Education</a></li>
          <li><a href="#contact" className="nav-link" onClick={(e) => handleNavClick(e, '#contact')}>Contact</a></li>
        </ul>
        <div className="hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
};

export default Header;

